import React from "react";

const bodyText =
  "mt-4 text-[15px] leading-relaxed text-slate-700 first:mt-0 md:text-base";
const listClass =
  "mt-4 list-disc space-y-2 pl-5 text-[15px] leading-relaxed text-slate-700 first:mt-0 md:text-base";

function isBulletLine(line) {
  return line.startsWith("- ") || line.startsWith("• ");
}

function stripBullet(line) {
  if (line.startsWith("- ")) return line.slice(2);
  if (line.startsWith("• ")) return line.slice(2);
  return line;
}

/**
 * Renders article content: paragraphs split by blank lines; lines starting with "## " become h2;
 * lines starting with "- " or "• " render as bullet lists (optionally after a leading paragraph in the same block).
 */
function BlogArticleBody({ content }) {
  const blocks = content.trim().split(/\n\n+/);
  return (
    <div className="max-w-2xl [&>*:first-child]:mt-0">
      {blocks.map((block, i) => {
        const trimmed = block.trim();
        if (!trimmed) return null;
        if (trimmed.startsWith("## ")) {
          return (
            <h2
              key={i}
              className="mt-8 text-xl font-semibold tracking-tight text-slate-900 first:mt-0 md:text-[1.35rem]"
            >
              {trimmed.slice(3)}
            </h2>
          );
        }

        const lines = trimmed.split("\n").map((l) => l.trim());
        const nonEmpty = lines.filter((l) => l !== "");

        if (nonEmpty.length === 0) return null;

        if (nonEmpty.every(isBulletLine)) {
          return (
            <ul key={i} className={listClass}>
              {nonEmpty.map((line, j) => (
                <li key={j}>{stripBullet(line)}</li>
              ))}
            </ul>
          );
        }

        const firstBulletIdx = nonEmpty.findIndex(isBulletLine);
        if (
          firstBulletIdx > 0 &&
          nonEmpty.slice(firstBulletIdx).every(isBulletLine)
        ) {
          const intro = nonEmpty.slice(0, firstBulletIdx).join(" ");
          const bullets = nonEmpty.slice(firstBulletIdx);
          return (
            <React.Fragment key={i}>
              <p className={bodyText}>{intro}</p>
              <ul className={listClass}>
                {bullets.map((line, j) => (
                  <li key={j}>{stripBullet(line)}</li>
                ))}
              </ul>
            </React.Fragment>
          );
        }

        return (
          <p key={i} className={bodyText}>
            {nonEmpty.join(" ")}
          </p>
        );
      })}
    </div>
  );
}

export default BlogArticleBody;
